// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { useFormikContext } from 'formik'
import styled from 'styled-components'

import { Button } from '@syconium/little-miss-figgy/dist/components/Button/Button'

import { FormSubmitContent } from '../form/FormSubmitContent'

export const FormSubmit = styled(
  ({
    children,
    className,
    submittingLabel,
  }: {
    className?: string
    children: React.ReactNode
    submittingLabel: string
  }) => {
    const formContext = useFormikContext()
    return (
      <Button className={className} type='submit'>
        <FormSubmitContent
          children={children}
          submittingLabel={submittingLabel}
          isSubmitting={formContext.isSubmitting}
        />
      </Button>
    )
  }
)`
  position: relative;
`
